module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp2_8023.681f3fed.png";